"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import { LandingSectionBadge } from "@/components/landing/LandingSectionBadge";

export default function PricingPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 py-16 lg:py-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Back link */}
            <Button
              asChild
              variant="ghost"
              className="mb-8"
            >
              <Link href="/">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to home
              </Link>
            </Button>

            {/* Page content */}
            <div className="mb-12 text-center">
              <div className="mb-6 flex justify-center">
                <LandingSectionBadge className="mb-0">Plans & pricing</LandingSectionBadge>
              </div>
              <h1 className="mb-4 text-4xl font-bold text-foreground sm:text-5xl lg:text-6xl">
                Pricing
              </h1>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Simple, transparent pricing that scales with your business
              </p>
            </div>

            {/* Placeholder content */}
            <div className="bg-card border border-border rounded-lg p-12 text-center">
              <p className="text-muted-foreground mb-6">
                Full pricing details coming soon. For now, check out our pricing
                teaser on the home page.
              </p>
              <Button asChild variant="primary">
                <Link href="/">View Home Page</Link>
              </Button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

